"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toaster = void 0;
var toaster = {
  list: {
    topRight: {
      top: '12px',
      right: '12px'
    },
    bottomRight: {
      bottom: '12px',
      right: '12px'
    },
    topLeft: {
      top: '12px',
      left: '12px'
    },
    bottomLeft: {
      bottom: '12px',
      left: '12px'
    }
  },
  toast: {
    primary: {
      root: {
        backgroundColor: 'highlight',
        color: 'text'
      },
      close: {},
      description: {},
      icon: {},
      title: {}
    },
    success: {
      root: {
        backgroundColor: 'green'
      },
      close: {},
      description: {},
      icon: {},
      title: {}
    },
    warning: {
      root: {
        backgroundColor: 'red'
      },
      close: {},
      description: {},
      icon: {},
      title: {}
    }
  }
};
exports.toaster = toaster;